import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-authorization-dialog',
  imports: [MatButtonModule, MatIconModule, MatDialogModule],
  templateUrl: './authorization-dialog.component.html',
  styleUrl: './authorization-dialog.component.scss'
})
export class AuthorizationDialogComponent {
  private dialogRef = inject(MatDialogRef<AuthorizationDialogComponent>);
  @ViewChild('printArea', { static: true }) printArea!: ElementRef<HTMLElement>;

  onCancel(): void {
    this.dialogRef.close();
  }

onPrint(): void {
  const node = this.printArea?.nativeElement;
  if (!node) return;

  const html = node.innerHTML;

  // collect styles from the current page so print looks correct
  const headNodes = Array.from(
    document.querySelectorAll('link[rel="stylesheet"], style')
  ).map(n => (n as HTMLElement).outerHTML).join('\n');

  // create a hidden iframe
  const iframe = document.createElement('iframe');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  document.body.appendChild(iframe);

  const doc = iframe.contentDocument || iframe.contentWindow?.document;
  if (!doc) return;

  doc.open();
  doc.write(`
    <html>
      <head>
        <title>Autopay Enrollment Authorization</title>
        <base href="${document.baseURI}">
        ${headNodes}
        <style>
          @page { margin: 16mm; }
          .no-print { display: none !important; }
        </style>
      </head>
      <body>
        <div class="authorization-dialog">
          ${html}
        </div>
      </body>
    </html>
  `);
  doc.close();

  const printAndCleanup = () => {
    const win = iframe.contentWindow!;
    const cleanup = () => setTimeout(() => iframe.remove(), 300);
    // prefer afterprint if supported
    if ('onafterprint' in win) {
      win.addEventListener('afterprint', cleanup, { once: true });
    } else {
      // fallback cleanup
      setTimeout(cleanup, 500);
    }

    // Focus then print
    win.focus();
    win.print();
  };

  // Ensure fonts/styles are ready before printing (prevents blank pages)
  const whenReady = () => {
    const fonts = (doc as any).fonts;
    if (fonts && fonts.ready) {
      fonts.ready.then(printAndCleanup).catch(printAndCleanup);
    } else {
      printAndCleanup();
    }
  };

  // If DOMContentLoaded already fired, go; else wait
  if (doc.readyState === 'complete' || doc.readyState === 'interactive') {
    whenReady();
  } else {
    iframe.addEventListener('load', whenReady, { once: true });
  }
}


}
